import { observer } from 'mobx-react'
import React, { useEffect } from 'react'

import {
   LoadingWrapper,
   useCustomT
} from '@flowwai-frontend/shared/common-components'
import { usePipelineStore } from '@flowwai-frontend/shared/sales-crm/sales-crm-core'
import { ErrorView } from '@flowwai-frontend/bps-officer-web/common/ui'
import { useGetPipelineTemplateBaseDetails } from '@flowwai-frontend/bps-officer-web/common/data-access'

import { ImageConstants } from '../GlobalSearchContentController/constants'
import GlobalSearchTemplateContentController from '../GlobalSearchTemplateContentController/GlobalSearchTemplateContentController'

const GlobalSearchTemplateController = (): React.ReactElement => {
   const {
      triggerAPI,
      apiStatus,
      apiError,
      templates
   } = useGetPipelineTemplateBaseDetails({})

   const pipelinesStore = usePipelineStore()
   const pipelines = pipelinesStore.pipelines

   const t = useCustomT('globalSearch:searchModal')

   const renderNoDataView = () => (
      <ErrorView
         imageUrl={ImageConstants.noDataViewImageUrl}
         description={t('noTemplatesFound')}
         containerClassName={'!h-[326px] !mb-0'}
      />
   )

   const renderSuccessView = () =>
      templates.length ? (
         <GlobalSearchTemplateContentController templates={templates} />
      ) : (
         renderNoDataView()
      )

   useEffect(() => {
      const templateIds = pipelines.map(
         pipeline => pipeline.pipelineItemTemplateId
      )
      const templateIdsSet = new Set(templateIds)

      const uniqueTemplateIds = Array.from(templateIdsSet)

      triggerAPI({
         templateIds: uniqueTemplateIds
      })
   }, [])

   return (
      <LoadingWrapper
         apiError={apiError}
         apiStatus={apiStatus}
         containerClassName='min-h-[100px]'
      >
         {renderSuccessView()}
      </LoadingWrapper>
   )
}

export default observer(GlobalSearchTemplateController)
